import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import clsx from 'clsx';
import { IconLoading } from '../../../../foundation/icons/IconLoading/index.js';
import { LoaderSizeXL } from '../sizes/index.js';
import { LoaderVariants } from '../types/index.js';
import { useStyles } from '../styles/index.js';
import { computeResponsiveness } from '../../../../foundation/responsive/helpers/index.js';

const Loader = forwardRef(({ variant = LoaderVariants.Local, size = LoaderSizeXL, isWithoutBackground, zIndex = 1, dataTestId, className, ...props }, ref) => {
    const sizes = computeResponsiveness(size);
    const styles = useStyles({ zIndex, isWithoutBackground, sizes });
    return (jsx("div", { ...props, className: clsx(styles.root, styles[variant], className), "data-testid": dataTestId || 'loader', ref: ref, children: jsx(IconLoading, { className: styles.icon, "data-testid": "loader-icon" }) }));
});
Loader.displayName = 'Loader';

export { Loader };
